import { render } from "./EnrolmentStrip.vue?vue&type=template&id=2a9bbb57&scoped=true"
import script from "./EnrolmentStrip.vue?vue&type=script&lang=js"
export * from "./EnrolmentStrip.vue?vue&type=script&lang=js"

import "./EnrolmentStrip.vue?vue&type=style&index=0&id=2a9bbb57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9bbb57"]])

export default __exports__